const SidebarSiteNavigationEnum = {
  SIDEBAR_SITE_NAVIGATION_ACTION_DUPLICATE: 'DUPLICATE',
  SIDEBAR_SITE_NAVIGATION_ACTION_FIND: 'FIND',
  SIDEBAR_SITE_NAVIGATION_ACTION_SEND: 'SEND',
  SIDEBAR_SITE_NAVIGATION_ACTION_SET: 'SIDEBAR_SITE_NAVIGATION_ACTION_SET',
  SIDEBAR_SITE_NAVIGATION_ACTION_SIGN: 'SIGN',
  SIDEBAR_SITE_NAVIGATION_ACTION_SHARE: 'SHARE',
  SIDEBAR_SITE_NAVIGATION_ACTION_UPLOAD: 'UPLOAD',
  SIDEBAR_SITE_NAVIGATION_SESSIONS_PANEL_CLOSE: 'SIDEBAR_SITE_NAVIGATION_SESSIONS_PANEL_CLOSE',
  SIDEBAR_SITE_NAVIGATION_SESSIONS_PANEL_OPEN: 'SIDEBAR_SITE_NAVIGATION_SESSIONS_PANEL_OPEN',
  SIDEBAR_SITE_NAVIGATION_USER_SESSIONS_GET: 'SIDEBAR_SITE_NAVIGATION_USER_SESSIONS_GET',
  SIDEBAR_SITE_NAVIGATION_USER_SESSIONS_GET_FAILURE: 'USER_SESSIONS_GET_FAILURE',
};

export const SidebarSiteNavigationHeaderText = {
  DUPLICATE: 'Duplicate a Document',
  SEND: 'Send for Signature',
  SIGN: 'Sign a Document',
  SHARE: 'Share a Document',
  UPLOAD: 'Upload a Document',
};

export default SidebarSiteNavigationEnum;



// WEBPACK FOOTER //
// ./src-react/SidebarSiteNavigation/SidebarSiteNavigationConstants.jsx